import type { Lang } from "@noli/core";
import { injectScope } from "./util";
export enum AlbumWords {
  pictureUnit = "pictureUnit", //张图
  unit = "unit", //张
  newAlbum = "newAlbum",
  backMyAlbum = "backMyAlbum",
  format = "format",
  cancelFormat = "cancelFormat",
  emptyAlbum = "emptyAlbum",
  noMore = "noMore",
  hasChose = "hasChose",
  toggleAll = "toggleAll",
  cancelToggleAll = "cancelToggleAll",
  changeAlbum = "changeAlbum",
  deleteImage = "deleteImage",
  addToAlbum = "addToAlbum",
  alreadyIn = "alreadyIn",
  alreadyInAlbum = "alreadyInAlbum",
  removeFromAlbum = "removeFromAlbum",
  cancel = "cancel",
  creatingAlbum = "creatingAlbum",
  createAlbumModalInputTitle = "createAlbumModalInputTitle",
  createAlbumModalInputPlaceholder = "createAlbumModalInputPlaceholder",
  confirmDelete = "confirmDelete",
  deleting = "deleting",
  deleteModalTitle = "deleteModalTitle",
  deleteModalContent = "deleteModalContent",
  deleteAlbumModalTitle = "deleteAlbumModalTitle",
  deleteAlbumModalOption1 = "deleteAlbumModalOption1",
  deleteAlbumModalOption2 = "deleteAlbumModalOption2",
  renameAlbumModalTitle = "renameAlbumModalTitle",
  renameAlbumModalLoading = "renameAlbumModalLoading",
  renameAlbumModalInputTitle = "renameAlbumModalInputTitle",
  renameAlbumModalPlaceholder = "renameAlbumModalPlaceholder",
  renameAlbumModalConfirm = "renameAlbumModalConfirm",
  menuOpRename = "menuOpRename",
  menuOpDelete = "menuOpDelete",
  menuOpCreate = "menuOpCreate",
}

injectScope("album", AlbumWords);

export const albumLangRecords: Record<Lang, Record<AlbumWords, string>> = {
  zh: {
    [AlbumWords.pictureUnit]: "张图",
    [AlbumWords.unit]: "张",
    [AlbumWords.newAlbum]: "新建分组",
    [AlbumWords.backMyAlbum]: "返回我的画册",
    [AlbumWords.format]: "内容整理",
    [AlbumWords.cancelFormat]: "取消整理",
    [AlbumWords.emptyAlbum]: "您还没有将任何内容加入该分组",
    [AlbumWords.noMore]: "已经到底了~",
    [AlbumWords.hasChose]: "已选择",
    [AlbumWords.toggleAll]: "全选",
    [AlbumWords.cancelToggleAll]: "取消全选",
    [AlbumWords.changeAlbum]: "修改分组",
    [AlbumWords.deleteImage]: "删除作品",
    [AlbumWords.addToAlbum]: "加入画册",
    [AlbumWords.alreadyIn]: "已加入:",
    [AlbumWords.alreadyInAlbum]: "已加入画册分组",
    [AlbumWords.removeFromAlbum]: "移出画册",
    [AlbumWords.cancel]: "取消",
    [AlbumWords.creatingAlbum]: "新建分组中...",
    [AlbumWords.createAlbumModalInputTitle]: "新建分组的名称",
    [AlbumWords.createAlbumModalInputPlaceholder]: "请输入分组名称",
    [AlbumWords.confirmDelete]: "确定删除",
    [AlbumWords.deleting]: "删除中...",
    [AlbumWords.deleteModalTitle]: "删除画册中选中的作品",
    [AlbumWords.deleteModalContent]: "删除作品后，将无法在画册中找到，确认删除？",
    [AlbumWords.deleteAlbumModalTitle]: "删除分组",
    [AlbumWords.deleteAlbumModalOption1]: "删除分组，但将分组中的内容放入“未分组”中",
    [AlbumWords.deleteAlbumModalOption2]: "删除分组，并将分组中的内容一并删除",
    [AlbumWords.renameAlbumModalTitle]: "修改分组名称",
    [AlbumWords.renameAlbumModalLoading]: "修改中...",
    [AlbumWords.renameAlbumModalInputTitle]: "将当前的分组名“$”修改为：",
    [AlbumWords.renameAlbumModalPlaceholder]: "请输入分组名称",
    [AlbumWords.renameAlbumModalConfirm]: "确认修改",
    [AlbumWords.menuOpRename]: "分组重命名",
    [AlbumWords.menuOpDelete]: "删除分组",
    [AlbumWords.menuOpCreate]: "创建分组",
  },
  en: {
    [AlbumWords.pictureUnit]: "Images",
    [AlbumWords.unit]: "Images",
    [AlbumWords.newAlbum]: "New Album",
    [AlbumWords.backMyAlbum]: "Back",
    [AlbumWords.format]: "Organize",
    [AlbumWords.cancelFormat]: "Cancel",
    [AlbumWords.emptyAlbum]: "Empty Album",
    [AlbumWords.noMore]: "At the end~",
    [AlbumWords.hasChose]: "Selected",
    [AlbumWords.toggleAll]: "Select All",
    [AlbumWords.cancelToggleAll]: "Cancel Select",
    [AlbumWords.changeAlbum]: "Change album",
    [AlbumWords.deleteImage]: "Remove image",
    [AlbumWords.addToAlbum]: "Add to album",
    [AlbumWords.alreadyIn]: "Added:",
    [AlbumWords.alreadyInAlbum]: "Added to album",
    [AlbumWords.removeFromAlbum]: "Remove",
    [AlbumWords.cancel]: "Cancel",
    [AlbumWords.creatingAlbum]: "Creating...",
    [AlbumWords.createAlbumModalInputTitle]: "New album name",
    [AlbumWords.createAlbumModalInputPlaceholder]: "Please enter new album name",
    [AlbumWords.confirmDelete]: "Confirm",
    [AlbumWords.deleting]: "Delete...",
    [AlbumWords.deleteModalTitle]: "Delete selected images",
    [AlbumWords.deleteModalContent]:
      "After deleting the image, it will not be found in the album. Confirm deletion?",
    [AlbumWords.deleteAlbumModalTitle]: "Delete Album",
    [AlbumWords.deleteAlbumModalOption1]: "Delete album and put images in default album",
    [AlbumWords.deleteAlbumModalOption2]: "Delete album both delete the images",
    [AlbumWords.renameAlbumModalTitle]: "Rename album",
    [AlbumWords.renameAlbumModalLoading]: "Renaming",
    [AlbumWords.renameAlbumModalInputTitle]: "Rename album '$' to:",
    [AlbumWords.renameAlbumModalPlaceholder]: "Please enter new album name",
    [AlbumWords.renameAlbumModalConfirm]: "Confirm",
    [AlbumWords.menuOpRename]: "Rename album",
    [AlbumWords.menuOpDelete]: "Delete album",
    [AlbumWords.menuOpCreate]: "Create album",
  },
};
